<template>
  <div>
    <v-row class="pb-6" v-if="selectedQuotationAgro != null">
      <v-col cols="12">
        <p class="primary--text form__title">
          COTAÇÃO ESCOLHIDA
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Tipo de Seguro
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationAgro.tipo_seguro.name }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Seguradora
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationAgro.seguradora.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Regulação de Sinistro
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationAgro.tipo_reivindicacao.name }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Coberturas
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationAgro.tipo_cobertura.name }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Importância Segurada(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.importancia_segurada) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Produtividade Garantida
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationAgro.producao_garantida }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Preço Saca(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.custo_por_saca) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Preço Total(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.custo_total) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Comissão(%)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationAgro.comissao }}
        </p>
      </v-col>
      <v-col
        v-if="this.selectedQuotationAgro.subvencao_federal != null"
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
      >
        <p class="form__label primary--text mb-2">
          Subvenção Federal(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.subvencao_federal) }}
        </p>
      </v-col>
      <v-col
        v-if="this.selectedQuotationAgro.subvencao_estadual != null"
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
      >
        <p class="form__label primary--text mb-2">
          Subvenção Estadual(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.subvencao_estadual) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Preço do Segurado(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.custo_segurado) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Preço do Produtor(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationAgro.custo_produtor) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Forma de Pagamento
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.forma_pagamento.name }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6" v-if="selectedQuotationCafezal != null">
      <v-col cols="12">
        <p class="primary--text form__title">
          COTAÇÃO ESCOLHIDA
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Seguradora
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationCafezal.seguradora.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Área Segurada (ha)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationCafezal.area_segurada }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Valor da Planta(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.valor_planta) }}
        </p>
      </v-col>
      <v-col cols="12" class="pr-sm-5 pb-2">
        <p class="form__title primary--text mb-2">
          Coberturas
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
        v-if="this.selectedQuotationCafezal.granizo > 0"
      >
        <p class="form__label primary--text mb-2">
          Granizo (R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.granizo) }}
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
        v-if="this.selectedQuotationCafezal.granizo_geada > 0"
      >
        <p class="form__label primary--text mb-2">
          Granizo e Geada (R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.granizo_geada) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Perda Produção Futura(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{
            asMoneyString(this.selectedQuotationCafezal.perda_producao_futura)
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Tratamento Fitossanitário(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{
            asMoneyString(
              this.selectedQuotationCafezal.tratamento_fitossanitario
            )
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          POS
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationCafezal.tipo_pos.name }}
        </p>
      </v-col>
      <v-col
        v-if="this.selectedQuotationCafezal.subvencao_federal != null"
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
      >
        <p class="form__label primary--text mb-2">
          Subvenção Federal(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.subvencao_federal) }}
        </p>
      </v-col>
      <v-col
        v-if="this.selectedQuotationCafezal.subvencao_estadual != null"
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
      >
        <p class="form__label primary--text mb-2">
          Subvenção Estadual(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.subvencao_estadual) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Prêmio do Segurado(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.premio_segurado) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Prêmio Total(R$)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(this.selectedQuotationCafezal.premio_total) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Comissão(%)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ this.selectedQuotationCafezal.comissao }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Forma de Pagamento
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.forma_pagamento.name }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="primary--text form__title mt-5">
          DADOS DA SOLICITAÇÃO
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Criado em
        </p>
        <p class="body-2 primary--text mb-7">
          {{ formatIsoDateToDDMMYYYYHHMM(form.criada_em) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Criado por
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.criada_por.nome }}
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Produto
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.modalidade.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Cultura
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.submodalidade.nome }}
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
        v-if="form.grupo_economico != null"
      >
        <p class="form__label primary--text mb-2">
          Grupo Econômico
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.grupo_economico.nome }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="font-weight-bold primary--text form__title">
          SEGURADO
        </p>
      </v-col>
      <v-col sm="3" md="3" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          CPF/CNPJ
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.numero_documento }}
        </p>
      </v-col>
      <v-col sm="6" md="6" class="pr-0 pr-sm-5 pr-md-0">
        <p class="form__label primary--text mb-2">
          Nome
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.nome }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.data_nascimento != null"
      >
        <p class="form__label primary--text mb-2">
          Data de Nascimento
        </p>
        <p class="body-2 primary--text mb-7">
          {{ formatDateToDDMMYYYY(form.segurado.data_nascimento) }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.genero != null"
      >
        <p class="form__label primary--text mb-2">
          Gênero
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.genero.name }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.tipo_documento != null"
      >
        <p class="form__label primary--text mb-2">
          Tipo de Documento
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.tipo_documento.name }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.numero_documento_extra != null"
      >
        <p class="form__label primary--text mb-2">
          Número do Documento
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.numero_documento_extra }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.orgao_expedidor != null"
      >
        <p class="form__label primary--text mb-2">
          Orgão Expedidor/UF
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.orgao_expedidor }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.data_expedicao != null"
      >
        <p class="form__label primary--text mb-2">
          Data de Expedição
        </p>
        <p class="body-2 primary--text mb-7">
          {{ formatDateToDDMMYYYY(form.segurado.data_expedicao) }}
        </p>
      </v-col>
      <v-col
        sm="3"
        md="3"
        class="pr-0 pr-sm-5 pr-md-0"
        v-if="form.segurado.estado_civil != null"
      >
        <p class="form__label primary--text mb-2">
          Estado Civil
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.estado_civil.name }}
        </p>
      </v-col>
      <v-col sm="3" md="3" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          Celular
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.celular }}
        </p>
      </v-col>
      <v-col sm="3" md="3" class="pr-0 pr-sm-5 pr-md-0">
        <p class="form__label primary--text mb-2">
          E-mail
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.email }}
        </p>
      </v-col>
      <v-row v-if="form.segurado.endereco != null">
        <v-col
          sm="3"
          md="3"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.cep != null"
        >
          <p class="form__label primary--text mb-2">
            Cep
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.cep }}
          </p>
        </v-col>
        <v-col
          sm="6"
          md="6"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.cidade != null"
        >
          <p class="form__label primary--text mb-2">
            Município
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.cidade }}
          </p>
        </v-col>
        <v-col
          sm="3"
          md="3"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.uf != null"
        >
          <p class="form__label primary--text mb-2">
            UF
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.uf.name }}
          </p>
        </v-col>
        <v-col
          sm="3"
          md="3"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.bairro != null"
        >
          <p class="form__label primary--text mb-2">
            Bairro
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.bairro }}
          </p>
        </v-col>
        <v-col
          sm="3"
          md="3"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.logradouro != null"
        >
          <p class="form__label primary--text mb-2">
            Logradouro
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.logradouro }}
          </p>
        </v-col>
        <v-col
          sm="3"
          md="3"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.numero != null"
        >
          <p class="form__label primary--text mb-2">
            Número
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.numero }}
          </p>
        </v-col>
        <v-col
          sm="3"
          md="3"
          class="pr-0 pr-sm-5 pr-md-0"
          v-if="form.segurado.endereco.complemento != null"
        >
          <p class="form__label primary--text mb-2">
            Complemento
          </p>
          <p class="body-2 primary--text mb-7">
            {{ form.segurado.endereco.complemento }}
          </p>
        </v-col>
      </v-row>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6" v-if="form.valor_credito_rural">
      <v-col cols="12">
        <p class="font-weight-bold primary--text form__title">
          CRÉDITO RURAL
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          CNPJ
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.documento_credito_rural }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          A favor de
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.nome_credito_rural }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Valor do crédito
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(form.valor_credito_rural) }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6" v-if="form.area_risco.cep !== null">
      <v-col cols="12">
        <p class="font-weight-bold primary--text form__title">
          LOCAL DE RISCO
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          CEP
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.area_risco.cep || "" }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
        <p class="form__label primary--text mb-2">
          Cidade
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.area_risco.cidade || "" }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          UF
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.area_risco.uf.name || "" }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row
      class="pb-6"
      v-if="form.itens_agricola.length > 0 || form.itens_cafezal.length > 0"
    >
      <v-row cols="12">
        <p class="font-weight-bold primary--text form__title mt-4 mb-7">
          Áreas Cadastradas
        </p>
      </v-row>
      <v-row v-if="form.itens_agricola.length > 0">
        <v-row
          v-for="(item, index) in form.itens_agricola"
          :key="index"
          class="mb-7"
        >
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Nome
            </p>
            <p class="body-2 primary--text">
              {{ item.nome }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Área Plantada
            </p>
            <p class="body-2 primary--text mb-7">
              {{ Number(item.area_plantada).toFixed(2) }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Técnica de Plantio
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.tecnica_plantio.name }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Tipo de Solo
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.classificacao_solo.nome }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Data de Plantio
            </p>
            <p class="body-2 primary--text mb-7">
              {{ formatDateToDDMMYYYY(item.data_plantio) }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Reivindicar Colheita Atual
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.reivindicar_colheita_atual ? "SIM" : "NÃO" }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              A lavoura já está plantada?
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.plantado ? "SIM" : "NÃO" }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Primeiro Ano de Plantio
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.primeiro_ano_plantio ? "SIM" : "NÃO" }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Soja após Cana de Açúcar
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.soja_apos_cana_acucar ? "SIM" : "NÃO" }}
            </p>
          </v-col>
          <v-spacer />
          <v-col sm="4" md="4" v-if="item.endereco != null">
            <p class="form__label primary--text mb-2">
              Logradouro
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.logradouro }}
            </p>
          </v-col>
          <v-col sm="4" md="4" v-if="item.endereco != null">
            <p class="form__label primary--text mb-2">
              Número
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.numero }}
            </p>
          </v-col>
          <v-col sm="4" md="4" v-if="item.endereco != null">
            <p class="form__label primary--text mb-2">
              Bairro
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.bairro }}
            </p>
          </v-col>
          <v-col
            sm="4"
            md="4"
            v-if="item.endereco != null && item.endereco.complemento != null"
          >
            <p class="form__label primary--text mb-2">
              Complemento
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.complemento }}
            </p>
          </v-col>
          <v-col sm="6" md="6" v-if="item.car != '' && item.car != null">
            <p class="form__label primary--text mb-2">
              CAR
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.car }}
            </p>
          </v-col>
          <v-spacer />
          <v-col
            sm="12"
            md="12"
            v-if="item.roteiro_acesso != '' && item.roteiro_acesso != null"
          >
            <p class="form__label primary--text mb-2">
              Roteiro de Acesso
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.roteiro_acesso }}
            </p>
          </v-col>
          <v-spacer />
          <v-row v-if="item.coordenadas.length > 0">
            <v-col sm="6" md="6">
              <p class="form__label primary--text mb-2">
                Coordenadas
              </p>
              <p
                v-for="coordenada in item.coordenadas"
                :key="coordenada.id"
                class="body-2 primary--text mb-2"
              >
                {{ coordenada.latitude }}, {{ coordenada.longitude }}
              </p>
            </v-col>
            <v-col sm="6" md="6">
              <p class="form__label primary--text mb-2">
                Arquivo Kml
              </p>
              <DocumentDataTable
                v-if="item.coordenadas.length > 0"
                class="mb-5"
                :documents="kmlFileConverter(item)"
                :viewButton="true"
                :deleteButton="false"
                @preview-file="onPreviewFile"
              />
            </v-col>
          </v-row>
          <v-col cols="12" class="pt-3">
            <v-divider />
          </v-col>
        </v-row>
      </v-row>
      <v-row v-if="form.itens_cafezal.length > 0">
        <v-row
          v-for="(item, index) in form.itens_cafezal"
          :key="index"
          class="mb-9"
        >
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Nome
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.nome }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Área Plantada
            </p>
            <p class="body-2 primary--text mb-7">
              {{ Number(item.area_plantada).toFixed(2) }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">Espécie</p>
            <p class="body-2 primary--text mb-7">
              {{ item.especie_cafe.name }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">Variedade</p>
            <p class="body-2 primary--text mb-7">
              {{ item.variedade_cafe.name }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">Sistema de Cultivo</p>
            <p class="body-2 primary--text mb-7">
              {{ item.sistema_cultivo_cafe.name }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Idade da Planta (Anos)
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.idade }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Espaçamento entre Plantas (m)
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.espacamento_plantas }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Espaçamento entre Linhas (m)
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.espacamento_linhas }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pr-0 pr-md-5">
            <p class="form__label primary--text mb-2">
              Data da última recepa
            </p>
            <p
              v-if="item.data_ultima_recepa != null"
              class="body-2 primary--text mb-7"
            >
              {{ formatDateToDDMMYYYY(item.data_ultima_recepa) }}
            </p>
            <p v-else class="body-2 primary--text mb-7">
              {{ "Não houve" }}
            </p>
          </v-col>
          <v-spacer />
          <v-col sm="4" md="4" v-if="item.endereco.logradouro != null">
            <p class="form__label primary--text mb-2">
              Logradouro
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.logradouro }}
            </p>
          </v-col>
          <v-col sm="4" md="4" v-if="item.endereco.numero != null">
            <p class="form__label primary--text mb-2">
              Número
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.numero }}
            </p>
          </v-col>
          <v-col sm="4" md="4" v-if="item.endereco.bairro != null">
            <p class="form__label primary--text mb-2">
              Bairro
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.bairro }}
            </p>
          </v-col>
          <v-col
            sm="4"
            md="4"
            v-if="item.endereco != null && item.endereco.complemento != null"
          >
            <p class="form__label primary--text mb-2">
              Complemento
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.endereco.complemento }}
            </p>
          </v-col>
          <v-col sm="6" md="6" v-if="item.car != '' && item.car != null">
            <p class="form__label primary--text mb-2">
              CAR
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.car }}
            </p>
          </v-col>
          <v-spacer />
          <v-col
            sm="12"
            md="12"
            v-if="item.roteiro_acesso != '' && item.roteiro_acesso != null"
          >
            <p class="form__label primary--text mb-2">
              Roteiro de Acesso
            </p>
            <p class="body-2 primary--text mb-7">
              {{ item.roteiro_acesso }}
            </p>
          </v-col>
          <v-spacer />
          <v-row v-if="item.coordenadas.length > 0">
            <v-col sm="6" md="6">
              <p class="form__label primary--text mb-2">
                Coordenadas
              </p>
              <p
                v-for="coordenada in item.coordenadas"
                :key="coordenada.id"
                class="body-2 primary--text mb-2"
              >
                {{ coordenada.latitude }}, {{ coordenada.longitude }}
              </p>
            </v-col>
            <v-col sm="6" md="6">
              <p class="form__label primary--text mb-2">
                Arquivo Kml
              </p>
              <DocumentDataTable
                v-if="item.coordenadas.length > 0"
                class="mb-5"
                :documents="kmlFileConverter(item)"
                :viewButton="true"
                :deleteButton="false"
                @preview-file="onPreviewFile"
              />
            </v-col>
          </v-row>
          <v-col cols="12" class="pt-3">
            <v-divider />
          </v-col>
        </v-row>
      </v-row>
      <v-row v-if="onPreviewFiles.length > 0">
        <v-col cols="12" sm="6" md="6">
          <p class="font-weight-bold primary--text form__title">
            Arquivos anexados
          </p>
          <DocumentDataTable
            class="mb-5"
            :documents="this.onPreviewFiles"
            :viewButton="true"
            :deleteButton="false"
            @preview-file="onPreviewFile"
          />
        </v-col>
      </v-row>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" xl="2">
          <BaseButton
            v-html="'VOLTAR'"
            class="white--text secondary"
            width="100%"
            @click="returnQuotation"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>
<script>
import {
  formatIsoDateToDDMMYYYYHHMM,
  formatDateToDDMMYYYY,
  asMoneyString
} from "@/utils/formats.js";
import DocumentDataTable from "@/components/DocumentDataTable";
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  mixins: [DocumentsMixin],
  data: () => ({
    startTerm: "DD/MM/AAAA",
    endTerm: "DD/MM/AAAA",
    asMoneyString,
    formatIsoDateToDDMMYYYYHHMM,
    formatDateToDDMMYYYY
  }),
  components: {
    DocumentDataTable
  },
  methods: {
    kmlFileConverter(item) {
      let kmlFile = [];
      if (this.form.itens_agricola.length > 0) {
        if (item.arquivo_kml_link != null) {
          kmlFile.push({
            url: item.arquivo_kml_link,
            nome: "Atualizado: " + item.arquivo_kml_nome
          });
        }
        item.coordenadas_kml.forEach(file =>
          kmlFile.push({
            url: file.arquivo_link,
            nome: "Original: " + file.arquivo_nome
          })
        );
      } else if (this.form.itens_cafezal.length > 0) {
        if (item.arquivo_kml_link != null) {
          kmlFile.push({
            url: item.arquivo_kml_link,
            nome: "Atualizado: " + item.arquivo_kml_nome
          });
        }
        item.coordenadas_kml.forEach(file =>
          kmlFile.push({
            url: file.arquivo_link,
            nome: "Original: " + file.arquivo_nome
          })
        );
      }

      return kmlFile;
    },
    returnQuotation() {
      this.$emit("return");
    }
  },
  computed: {
    selectedQuotationAgro() {
      let selectedCost = null;
      if (this.form.custos != null) {
        selectedCost = this.form.custos.filter(x => x.aprovada_em != null);
        selectedCost = selectedCost?.length > 0 ? selectedCost[0] : null;
      }

      return selectedCost;
    },
    selectedQuotationCafezal() {
      let selectedCost = null;
      if (this.form.custos_cafezal != null) {
        selectedCost = this.form.custos_cafezal.filter(
          x => x.aprovada_em != null
        );
        selectedCost = selectedCost?.length > 0 ? selectedCost[0] : null;
      }
      return selectedCost;
    },
    onPreviewFiles() {
      let files = [];

      if (this.form.custos_cafezal != null) {
        this.form.custos_cafezal.forEach(item => {
          if (item.arquivo_link != null) {
            files.push({
              url: item.arquivo_link,
              nome: "Proposta: " + item.arquivo_nome
            });
          }

          if (item.arquivo_apolice_link != null) {
            files.push({
              url: item.arquivo_apolice_link,
              nome: "Apólice: " + item.arquivo_apolice_nome
            });
          }

          if (item.boletos.length > 0) {
            item.boletos.forEach(itens => {
              files.push({
                url: itens.url,
                nome: "Boleto: " + itens.nome
              });
            });
          }

          if (item.documentos_conformidade != null) {
            item.documentos_conformidade.forEach(itens => {
              if (itens.arquivo_link != null) {
                files.push({
                  url: itens.arquivo_link,
                  nome: "Arquivo Conformidade: " + itens.arquivo_nome
                });
              }
            });
          }
        });
      }

      if (this.form.custos != null) {
        this.form.custos.forEach(item => {
          if (item.arquivo_link != null) {
            files.push({
              url: item.arquivo_link,
              nome: "Proposta: " + item.arquivo_nome
            });
          }

          if (item.arquivo_apolice_link != null) {
            files.push({
              url: item.arquivo_apolice_link,
              nome: "Apólice: " + item.arquivo_apolice_nome
            });
          }

          if (item.boletos != null) {
            item.boletos.forEach(itens => {
              files.push({
                url: itens.url,
                nome: "Boleto: " + itens.nome
              });
            });
          }

          if (item.documentos_conformidade != null) {
            item.documentos_conformidade.forEach(itens => {
              if (itens.arquivo_link != null) {
                files.push({
                  url: itens.arquivo_link,
                  nome: itens.tipo_conformidade.name + ": " + itens.arquivo_nome
                });
              }
            });
          }
        });
      }

      if (
        this.selectedQuotationAgro != null ||
        this.selectedQuotationCafezal != null
      ) {
        let link = this.$router.resolve(`/print-quotation/${this.form.id}`)
          .href;
        files.push({
          url: link,
          nome: "Cotação Aprovada"
        });
      }

      return files;
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
